import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-custom-alert',
  templateUrl: './custom-alert.component.html',
  styleUrls: ['./custom-alert.component.css']
})
export class CustomAlertComponent implements OnInit {
  title: string;
  msg: string;

  constructor(
    private dialogRef: MatDialogRef<CustomAlertComponent>,
    @Inject(MAT_DIALOG_DATA) private data: CustomAlertInput
  ) { }

  ngOnInit() {
    this.title = this.data.title;
    this.msg = this.data.msg;
  }

  onCloseModal(event: any){
    this.dialogRef.close();
  }
}

interface CustomAlertInput {
  title: string,
  msg: string
}